import { get, post,put,destroy } from "./base";

 const ProductTagServ = {
  index: (params) => get("/ProductTags", { params }),
  single: (id) => get(`/ProductTags/${id}`),
  create: (payload) => post("/ProductTags", payload),
  update: (id, payload) => put(`/ProductTags/${id}`, payload),
  remove: (id) => destroy(`/ProductTags/${id}`),


};

export default ProductTagServ;
